import { Outlet, createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/settings/compliance')({
  component: RouteComponent,
});

function RouteComponent() {
  return <Outlet />;
}
